import React from 'react';
import { Plus, PartyPopper, Users, RefreshCw, Activity } from 'lucide-react';
import QuickActionCard from '../../shared/QuickActionCard';

const QuickActions = ({ onNavigate, permissions }) => {
    return (
        <div
            className="rounded-xl shadow-sm p-6 mb-6"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)' }}
        >
            <h3 className="text-lg font-bold mb-4">Quick Actions</h3>
            <div className="grid grid-cols-2 gap-4">

                {permissions.canManageTeams && (
                    <QuickActionCard
                        icon={Plus}
                        title="Add Team"
                        description="Create new team"
                        onClick={() => onNavigate('create-team')}
                        color="green"
                    />
                )}

                {permissions.canManageTeams && (
                    <QuickActionCard
                        icon={Plus}
                        title="New Tournament"
                        description="Start tournament"
                        onClick={() => onNavigate('create-tournament')}
                        color="blue"
                    />
                )}

                {permissions.canManageTeams && (
                    <QuickActionCard
                        icon={Plus}
                        title="Add Game"
                        description="Schedule a game"
                        onClick={() => onNavigate('add-game')}
                        color="purple"
                    />
                )}

                {permissions.canManageTeams && (
                    <QuickActionCard
                        icon={RefreshCw}
                        title="Sync Schedule"
                        description="From CricClubs"
                        onClick={() => onNavigate('sync-schedule')}
                        color="teal"
                    />
                )}

                {permissions.isAdmin && (
                    <QuickActionCard
                        icon={Users}
                        title="Member Stats"
                        description="View registration stats"
                        onClick={() => onNavigate('member-stats')}
                        color="indigo"
                    />
                )}

                {permissions.isAdmin && (
                    <QuickActionCard
                        icon={Activity}
                        title="Participation Stats"
                        description="Selection percentage"
                        onClick={() => onNavigate('participation-report')}
                        color="blue"
                    />
                )}

                {permissions.canManageFinancials && (
                    <QuickActionCard
                        icon={Plus}
                        title="Add Expense"
                        description="Record expense"
                        onClick={() => onNavigate('manage-expenses', { tab: 'add' })}
                        color="orange"
                    />
                )}

                {permissions.canManageEvents && (
                    <QuickActionCard
                        icon={PartyPopper}
                        title="Create Event"
                        description="Club event"
                        onClick={() => onNavigate('add-event')}
                        color="pink"
                    />
                )}
            </div>
        </div>
    );
};

export default QuickActions;
